import { GET } from '@/request/index'
import URL from '@/request/api/url'

export const fetchRecruitmentList = () => {
  return GET(URL.RECRUITMENT_LIST)
}
